export class UserTelegramConnection {
  idUserTelegramConnection: number;
  idUser: number;
  chatId: number | null;
  token: string | null;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  languageCode: string | null;
  active: boolean;
  deactivatedByUser: boolean;

  constructor(
    idUserTelegramConnection: number,
    idUser: number,
    chatId: number | null,
    token: string | null,
    username: string | null,
    firstName: string | null,
    lastName: string | null,
    languageCode: string | null,
    active: boolean,
    deactivatedByUser: boolean
  ) {
    this.idUserTelegramConnection = idUserTelegramConnection;
    this.idUser = idUser;
    this.chatId = chatId;
    this.token = token;
    this.username = username;
    this.firstName = firstName;
    this.lastName = lastName;
    this.languageCode = languageCode;
    this.active = active;
    this.deactivatedByUser = deactivatedByUser;
  }

  static fromRaw(raw: any): UserTelegramConnection {
    return new UserTelegramConnection(
      raw.idUserTelegramConnection,
      raw.idUser,
      raw.chatId ?? null,
      raw.token ?? null,
      raw.username ?? null,
      raw.firstName ?? null,
      raw.lastName ?? null,
      raw.languageCode ?? null,
      Boolean(raw.active),
      Boolean(raw.deactivatedByUser)
    );
  }

  clone(): UserTelegramConnection {
    return new UserTelegramConnection(
      this.idUserTelegramConnection,
      this.idUser,
      this.chatId,
      this.token,
      this.username,
      this.firstName,
      this.lastName,
      this.languageCode,
      this.active,
      this.deactivatedByUser
    );
  }

  toPayload(): any {
    const payload: any = {
      idUser: this.idUser,
      chatId: this.chatId,
      token: this.token,
      username: this.username,
      firstName: this.firstName,
      lastName: this.lastName,
      languageCode: this.languageCode,
      active: this.active,
      deactivatedByUser: this.deactivatedByUser
    };

    if (this.idUserTelegramConnection !== 0) {
      payload.idUserTelegramConnection = this.idUserTelegramConnection;
    }

    return payload;
  }
}
